
import bigDataLog from '@/utils/bigDataLogV2.js';
// 埋点公共类
const trackDataInfo = {
    // 功能1
    model_name1: '',
    // 功能2
    model_name2: '',
    // 功能3
    model_name3: ''
};
let levelCount = 0;
const isMenuType = (info) => {
    if (info.resourceType === 1 || info.resourceType === 2) {
        return true;
    }
    return false;
};
const setInfo = (resourceName, level) => {
    const resetLevel2 = () => {
        trackDataInfo['model_name2'] = '';
        trackDataInfo['model_name3'] = '';
    };
    const resetLevel3 = () => {
        trackDataInfo['model_name3'] = '';
    };
    let setInfoKey = '';
    if (level === 1) {
        setInfoKey = 'model_name1';
        resetLevel2();
    } else if (level === 2) {
        setInfoKey = 'model_name2';
        resetLevel3();
    } else if (level === 3) {
        setInfoKey = 'model_name3';
    }
    trackDataInfo[setInfoKey] = resourceName;
};

export const sendInfoToBigData = () => {
    bigDataLog.sendDetailMessage(trackDataInfo);
};
export const getResourceNameByCode = (code, menus) => {
    levelCount++;
    for (let i = 0; i < menus.length; i++) {
        const item = menus[i];
        if (isMenuType(item)) {
            if (item.resourceCode === code) {
                setInfo(item.resourceName, levelCount);
                break;
            } else if (Reflect.has(item, 'subResources') && item.subResources.length > 0) {
                getResourceNameByCode(code, item.subResources);
            } else;
        }
    }
    levelCount--;
};
